// Copyright (c) Docugami, Inc. All rights reserved.

import { ConfirmationDialog } from "components/shell/utils/ConfirmationDialog";
import { useDeleteWorkPathsMutation } from "store/work_path/workPathSlice";
import { DeleteWorkPathSchema, TelemetryEvent } from "telemetry/TelemetryEvents";
import { Telemetry } from "telemetry/TelemetryManager";

interface DeleteWorkPathDialogProps {
    workPathId: string;
    onComplete: () => void;
    onCancel: () => void;
    isVisible: boolean;
}

/**
 * Dialog that presents the user with a delete confirmation. If confirmed, the work path will be deleted permanently.
 * @param props
 */
export const DeleteWorkPathDialog = (props: DeleteWorkPathDialogProps): JSX.Element => {
    const [triggerDelete, { isLoading }] = useDeleteWorkPathsMutation();

    async function onConfirm() {
        if (isLoading) {
            return;
        }

        const data = await triggerDelete([props.workPathId]).unwrap();

        if (data) {
            Telemetry.trackEvent<DeleteWorkPathSchema>({
                workPathId: props.workPathId,
                eventName: TelemetryEvent.DeleteWorkPath
            });
        }

        props.onComplete();
    }

    return <ConfirmationDialog
        hidden={!props.isVisible}
        title="Delete your project"
        subText="Project deletion is a permanent operation. Are you sure you want to delete it?"
        confirmButtonText="Delete"
        dismissButtonText="Cancel"
        confirmedCallback={onConfirm}
        dismissedCallback={props.onCancel} />
}
